"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../../assets/icons/controls/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(1)
    }
  };
});
/**
 * **Controls allow the user to select options.**
 *
 * There is 1 state: Checked
 */

var Favourite = function Favourite(_ref) {
  var name = _ref.name,
      checked = _ref.checked,
      _onChange = _ref.onChange;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Radio, {
    classes: {
      root: styles.root
    },
    checked: checked,
    name: name,
    color: "secondary",
    onChange: function onChange(e) {
      return _onChange(e);
    },
    icon: /*#__PURE__*/_react.default.createElement(_core.SvgIcon, {
      component: _icons.ic_Favourite__default,
      viewBox: "0 0 24 24"
    }),
    checkedIcon: /*#__PURE__*/_react.default.createElement(_core.SvgIcon, {
      component: _icons.ic_Favourite__checked,
      viewBox: "0 0 24 24"
    })
  });
};

Favourite.propTypes = {
  /** Name prop of form element */
  name: _propTypes.default.string,

  /** Checked state of the checkbox */
  checked: _propTypes.default.bool,

  /** Function to call onChange event */
  onChange: _propTypes.default.func.isRequired
};
Favourite.defaultProps = {
  name: null,
  checked: false
};
var _default = Favourite;
exports.default = _default;